const globalConfig = window.gileadeMapsGlobal
if (!globalConfig) {
  console.warn('Não foi encontrada a configuração para o gileade maps. gileadeMapsGlobal')
}

const validate = key =>
  globalConfig && !globalConfig[key] && console.warn('Não foi encontrada a configuração: ' + key)

validate('clientId')
validate('apiURL')
validate('initialLatlng')
validate('initialZoom')

export default {...globalConfig}



// WEBPACK FOOTER //
// ./src/gileadeGlobalConfig.js